import { forwardRef } from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import "../../style/common/termCondition.scss";

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function TermConditionModal(props) {
    const {
        onClose,
        open,
        cancelRequired = true,
        dialogConfirmationTitle = "Confirmation",
        dialogConfirmationMessage = "Are Your Sure ?",
        showTitle = true,
        width = "auto",
        height = "auto",
        onConfirm,
        ...other
    } = props;

    const handleCancel = () => {
        onClose(false);
    };

    const handleOk = () => {
        onClose(true);
        if (onConfirm) {
            onConfirm(); // Call the onConfirm function if provided
        }
    };

    return (
        <Dialog
            sx={{
                "& .MuiDialog-paper": {
                    width: width,
                    height: height,
                    borderRadius: "10px",
                },
                '& .MuiDialogContent-root':{
                    borderBottom:"1px solid #FF7100"
                }
            }}
            maxWidth="xs"
            TransitionComponent={Transition}
            open={open}
            {...other}
            className="termCondition"
        >
            {showTitle && <DialogTitle>{dialogConfirmationTitle}</DialogTitle>}

            <DialogContent dividers>{dialogConfirmationMessage}</DialogContent>
            <DialogActions>
                {cancelRequired && (
                    <div className="dialog-cancel" >
                        <Button autoFocus onClick={handleCancel} sx={{color:"#FF7100"}}>
                            DON'T AGREE
                        </Button>
                    </div>
                )}
                {cancelRequired && <div className="vline"></div>}
                <div className="dialog-confirm">
                    <Button onClick={handleOk} sx={{color:"#FFFFFF"}}>AGREE</Button>
                </div>
            </DialogActions>
        </Dialog>
    );
}

TermConditionModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
};

export default TermConditionModal;
